import { authHeader, handleResponse } from "../helpers";
export const ExtraBenefitMasterService = {
  getCategory,
  createCategory,
  createContractor,
  createSubCategory,
  updateCategory,
  updateContractor,
  SubUpdateCategory,
  inActiveRow,
  approveUser,
  inActiveRow2,
  getSubCategory,
  fetchCategoryDLL,
  fetchSubCategoryDLL,
};

function approveUser(userId) {
  const requestOptions = {
      method: 'GET',
      headers: authHeader()
  };
  return fetch(`${process.env.REACT_APP_API_URL}UserMaster/ApproveUser/${userId}`, requestOptions)
      .then(handleResponse);
}



function getCategory(data) {
  
  if (!data || !data.First || !data.PageSize) {
    console.error("Missing required fields for GetExtraBenefit", data);
    return Promise.reject({ message: "Missing required fields" });
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetExtraBenefit`, requestOptions)
    .then(handleResponse);
}

function getSubCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetSubCategory`,
    requestOptions
  ).then(handleResponse);
}

function createCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/SaveExtraBenefit2`, // ✅ corrected route
    requestOptions
  ).then(handleResponse);
}

function createContractor(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InsertExtraBenefitContractor`,
    requestOptions
  ).then(handleResponse);
}

function createSubCategory(data) {
  console.log(data);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/CreateSubCategory`,
    requestOptions
  ).then(handleResponse);
}

function updateCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/SaveExtraBenefit2`,
    requestOptions
  ).then(handleResponse);
}

// function updateContractor(data) {
//   const requestOptions = {
//     method: "POST",
//     headers: authHeader(),
//     body: JSON.stringify(data),
//   };
//   return fetch(
//     `${process.env.REACT_APP_API_URL}CategoryMaster/InsertExtraBenefitContractor`,
//     requestOptions
//   ).then(handleResponse);
// }

function updateContractor(data) {
  ;
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InsertExtraBenefitContractorUpdated`,
    requestOptions
  ).then(handleResponse);
}

function SubUpdateCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/SubUpdateCategory`,
    requestOptions
  ).then(handleResponse);
}

function inActiveRow(batchid, isActive, obj) {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InActiveExtraBenefitBatchid/${batchid}/${isActive}`,
    requestOptions
  ).then(handleResponse);
}

function inActiveRow2(categoryId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InActiveRow2/${categoryId}/${isActive}`,
    requestOptions
  ).then(handleResponse);
}

function fetchCategoryDLL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetCategoryDLL`,
    requestOptions
  ).then(handleResponse);
}

function fetchSubCategoryDLL(data) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetSubCategoryDLL?categoryId=${data}`,
  ).then(handleResponse);
}
